import React, { FC } from 'react'
import Lottie from 'lottie-react'
import data from '../data.json'
import { SpinnerWrapper } from './Spinner.styles'
import { SpinnerProps } from './types'

const Spinner: FC<SpinnerProps> = props => {
  const { buttonMode } = props
  return (
    <SpinnerWrapper
      as={props.removeFullscreen ? 'section' : 'main'}
      {...props}
    >
      <Lottie
        aria-label='Loading Spinner'
        style={{
          width: buttonMode ? 24 : 100,
          height: buttonMode ? 24 : 100,
        }}
        animationData={data}
      />
    </SpinnerWrapper>
  )}

Spinner.defaultProps = {
  removeFullscreen: false,
  minHeight: false,
  buttonMode: false
}

export default Spinner
